<template>
  <div id="slate-int-calculator-output">
  	<back-button v-on:backButtonClick="goBack" />
    <div id='slate-int-calculator-result' />
  </div>
</template>

<script>
import BackButton from '../../.././slate-int-back-button/src/BackButton'

export default {
  name: 'calculatorOutput',
  props: ['state', 'result', 'renderFunc'],
  methods: {
    goBack () {
      this.$emit('goBack')
    }
  },
  watch: {
    state (newState) {
      if (newState === 1) {
        new Promise((resolve, reject) => {
          resolve(this.renderFunc(this.result))
        }).then(() => {
          this.$emit('resultRendered')
        }).catch((err) => alert(err))
      } else if (newState === 0) {
        this.renderFunc('clear')
      } else return
    }
  },
  components: {
    'back-button': BackButton
    // 'calc-result': () => import('.././instances/default/defaultResult.vue')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#slate-int-calculator-result {
  margin-top: 0.5em;
}
svg::text {
  font-family: 'sl-Apres';
}
</style>



// WEBPACK FOOTER //
// CalculatorOutput.vue?646e23d3